import { Tag, Tooltip } from "antd";
import { FaCheckCircle, FaExclamationCircle, FaTimesCircle } from "react-icons/fa";
import { EInvoiceStatus } from "../../../../enums";
import {SyncOutlined, LoadingOutlined} from '@ant-design/icons';
interface IProps {
  status: EInvoiceStatus;
  message?: string;
  showTooltip?: boolean;
}

export default function StatusTag({ status, message, showTooltip = true }: IProps) {
  let color = "#999";
  let icon: JSX.Element | null = null;
  let tooltipText = "";

  switch (status) {
    case EInvoiceStatus.completed:
      color = "#52c41a";
      icon = <FaCheckCircle/>;
      break;
    case EInvoiceStatus.error:
      color = "#ff4d4f";
      icon = <FaTimesCircle/>;
      tooltipText = message && message !== "Recusado" ? message : "Recusado";
      break;
    case EInvoiceStatus.warning:
      color = "#faad14";
      icon = <FaExclamationCircle />;
      tooltipText = message && message !== "Alerta" ? message : "Alerta";
      break;
    case EInvoiceStatus.processing:
      color = "#1890ff";
      icon = <LoadingOutlined spin  />;
      tooltipText = "Em processamento";
      break;
    case EInvoiceStatus.reprocessing:
      color = "#722ed1";
      icon = <SyncOutlined spin />;
      break;
    default:
      color = "#999";
      icon = null;
  }

  const statusText =
    status === EInvoiceStatus.error ? "Recusado" : status;

  const tagElement = (
    <Tag
      style={{
        backgroundColor: color + "20",
        color: color,
        fontWeight: 600,
        borderRadius: 16,
        border: `1px solid ${color + "40"}`,
        fontSize: 12,
        display: "flex",
        alignItems: "center",
        width: "fit-content",
        gap: 6,
      }}
    >
      {icon}
      {statusText}
    </Tag>
  );

  return showTooltip && tooltipText ? (
    <Tooltip title={tooltipText} color={color}>
      {tagElement}
    </Tooltip>
  ) : (
    tagElement
  );
}
